import Netcon from '../ReactCustomIcons/netcon-dark.png';
export const NetconDarkLogo: React.FC = () => {
  return (
    <>
      <img src={Netcon} alt="Netcon Logo" />
    </>
  );
};
